(ns minorodata.components.file-ingest.table-select
  (:require [applied-science.js-interop :as jsi]
            [clojure.set :as set]
            [clojure.string :as clojure.string]
            [minorodata.app.handlers :refer [dispatch dispatch-sync]]
            [minorodata.components.spinner.core :as c.spinner]
            [minorodata.file-ingest.utils :as fi.utils]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.button :refer [button]]
            [ui.card :refer [card]]
            [ui.fields :refer [input radio-group select]]
            [ui.stepper :as stepper]
            [ui.typography :as typography]))


(defn choose-table-and-proceed [table-type ingest-tables-set table-name set-table-name-error]
  (if (= table-type "new")
    (let [[valid? message] (fi.utils/valid-table-name? ingest-tables-set (or table-name ""))]
      (if valid?
        (dispatch [:file-ingest.events/set-ingest-table-params table-type table-name])
        (set-table-name-error message)))

    (if (some? table-name)
      (dispatch [:file-ingest.events/set-ingest-table-params table-type table-name])
      (set-table-name-error "Please select some table"))))


(defn new-table-control [{:keys [selected-table-type switch-table-type table-name table-name-error set-table-name]}]
  (let [active? (= selected-table-type "new")]
    [:div {:class "flex-1 max-w-lg"}
     [radio-group {:name            "table-type"
                   :value           selected-table-type
                   :options         [{:value "new"
                                      :text [:span {:class "font-medium"}
                                             "Import to the new table"]}]
                   :on-value-change #(switch-table-type %)}]

     [typography/p {:class "my-4 text-kleene-text-secondary"}
      "We will create the new table with this name and fulfill it with the data from the ingested file"]

     [input
      {:id            :new-table-name
       :label         "New table name"
       :type          "text"
       :input-props   {:data-cy :select-table__new-input}
       :default-value (if active? (or table-name "") "")
       :disabled      (not active?)
       :errors        {:new-table-name (when (and active? table-name-error)
                                         {:value table-name-error})}
       :on-change     #(set-table-name (-> (jsi/get-in % [:target :value])
                                           (clojure.string/trim)))}]]))


(defn existing-table-control
  [{:keys [selected-table-type switch-table-type table-name table-name-error set-table-name existing-tables]}]
  (let [active? (= selected-table-type "existing")]
    [:div {:class "flex-1 max-w-lg"}
     [radio-group {:name            "table-type"
                   :value           selected-table-type
                   :options         [{:value "existing"
                                      :text [:span {:class "font-medium"}
                                             "Import into existing table"]}]
                   :on-value-change #(switch-table-type %)}]

     [typography/p {:class "my-4 text-kleene-text-secondary"}
      "We will import the data from ingested file into this table. Note that imported columns should match columns in the database table"]


     [select {:value       (if active? (or table-name "") "")
              :error       (and active? (some? table-name-error))
              :helper      (if active? (or table-name-error "") "")
              :disabled    (not active?)
              :label       "Existing table"
              :placeholder "Select table"
              :native      false
              :options     (mapv #(set/rename-keys % {:label :text})
                                 existing-tables)
              :on-change   set-table-name}]]))


(defn table-select-render
  [{:keys [loading? table-type table-name switch-table-type table-name-error set-table-name existing-tables submit-form]}]
  [:<>
   [card {:class "p-4 flex justify-center items-center min-h-[300px] gap-12"}
    (if loading?
      [:div {:class "flex min-h-[200px] items-center justify-center text-kleene-text-secondary"}
       [c.spinner/with-text {:text "Loading..."}]]

      [:<>
       [new-table-control
        {:table-name          table-name
         :selected-table-type table-type
         :switch-table-type   switch-table-type
         :table-name-error    table-name-error
         :set-table-name      set-table-name}]

       [existing-table-control
        {:table-name          table-name
         :existing-tables     existing-tables
         :selected-table-type table-type
         :switch-table-type   switch-table-type
         :table-name-error    table-name-error
         :set-table-name      set-table-name}]])]

   [stepper/stepper-footer {:class "border-t-0"}
    [button {:data-cy  :table-select__submit
             :disabled (or loading? (empty? table-name))
             :on-click submit-form}
     "Proceed"]]])


(def initial-component-state
  {:table-type       "new"
   :table-name       nil
   :table-name-error nil})


(defn table-select []
  (let [loading              (re-posh/subscribe [:mold-http/loading? :file-ingest.api/load-ingest-tables])
        ingest-tables        (re-posh/subscribe [:ingest-tables/pull])
        ingest-tables-opts   (re-posh/subscribe [:file-ingest.subs/ingest-tables-options])
        local-state          (reagent/atom initial-component-state)
        switch-table-type    #(swap! local-state assoc :table-type % :table-name nil :table-name-error nil)
        set-table-name       #(swap! local-state assoc :table-name % :table-name-error nil)
        set-table-name-error #(swap! local-state assoc :table-name-error %)
        submit-form          (fn []
                               (let [{:keys [table-type table-name]} @local-state
                                     ingest-tables-set (set (:ingest-tables/tables @ingest-tables))]
                                 (choose-table-and-proceed table-type ingest-tables-set table-name set-table-name-error)))]
    (reagent/create-class
     {:display-name
      "table-select"

      :constructor
      (fn []
        (dispatch-sync [:file-ingest.api/load-ingest-tables]))

      :render
      (fn []
        (let [{:keys [table-type table-name table-name-error]} @local-state]
          [table-select-render
           {:loading?          @loading
            :table-name        table-name
            :table-type        table-type
            :existing-tables   @ingest-tables-opts
            :table-name-error  table-name-error
            :switch-table-type switch-table-type
            :set-table-name    set-table-name
            :submit-form       submit-form}]))})))
